// My CRM · Work log — a timeline of what the AM has done in the CRM.
import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, CheckCircle2, FileText, UserPlus, BadgeCheck } from "lucide-react";
import { useMyCrm, Chips, SearchBox, useDebounced, Empty, ago } from "./_shared";

const KINDS = { activity: ["Activities logged", Phone, "text-purple-300"], done: ["Completed", CheckCircle2, "text-emerald-300"], quote: ["Quotes", FileText, "text-amber-300"],
  customer: ["Customers assigned", UserPlus, "text-sky-300"], signup: ["Trade sign-ups", BadgeCheck, "text-teal-300"] };

export default function WorkLogTab({ amId, on360 }) {
  const [days, setDays] = useState(30);
  const [kind, setKind] = useState([]);
  const [q, setQ] = useState("");
  const dq = useDebounced(q);
  const { data, loading } = useMyCrm("worklog", { am_id: amId, days, kind: kind.join(","), q: dq });
  const fk = data?.facets?.kind || {};
  return (
    <div className="space-y-3" data-testid="mycrm-worklog">
      <div className="flex flex-wrap items-center gap-2">
        <Chips testid="mycrm-wl-kind" value={kind} onChange={setKind} items={Object.keys(KINDS).map((k) => [k, KINDS[k][0], fk[k] || 0])} />
        <div className="ml-auto flex flex-wrap gap-2">
          <SearchBox value={q} onChange={setQ} placeholder="Search the log…" testid="mycrm-wl-search" />
          <select className="ws-input !w-auto" value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="mycrm-wl-days">
            {[7, 30, 90, 365].map((d) => <option key={d} value={d}>Last {d === 365 ? "12 months" : `${d} days`}</option>)}
          </select>
        </div>
      </div>
      <div className="ws-card">
        {loading && !data ? <Empty text="Loading…" /> : !data.events.length ? <Empty text="No CRM work logged in this period." /> : (
          <ol className="divide-y divide-white/5">
            {data.events.map((e, i) => {
              const [, Icon, tone] = KINDS[e.kind] || KINDS.activity;
              return (
                <li key={`${e.kind}-${e.ts}-${i}`} className="flex items-start gap-3 px-4 py-2.5" data-testid={`mycrm-wl-event-${i}`}>
                  <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${tone}`} />
                  <div className="flex-1 min-w-0 text-[12.5px] text-slate-200">
                    {e.customer && <button className="font-medium text-white hover:underline mr-1.5" onClick={() => on360(e.person_id)} data-testid={`mycrm-wl-cust-${i}`}>{e.customer}</button>}
                    {e.quote_id ? <Link to={`/quotes/${e.quote_id}/edit`} className="hover:underline">{e.text}</Link> : e.text}
                  </div>
                  <span className="text-[11px] text-slate-500 whitespace-nowrap">{ago(e.ts)}</span>
                </li>
              );
            })}
          </ol>
        )}
      </div>
    </div>
  );
}
